import { guided } from '@/llm/guidedRuntime';
import { appPopulate } from '@/llm/appPopulate';
import { buildAppDefinition } from '@/build-core';
import type { AppKind } from '@/types/appKind';
import type { AppDefinition } from '@/types/app';
import { buildInputsFromStore } from '@/onboarding/buildInputs';
import { finalizeBuild } from '@/onboarding/finalizeBuild';

export function withKind(def: AppDefinition, kind: AppKind): AppDefinition {
  return { ...def, kind };
}

// Generates the app from the current onboarding state, applies the chosen vibe
// theme, and persists it. Returns the new project's id. Throws on LLM/credit errors
// so the caller can route to the paywall. Assumes the caller has confirmed sign-in.
// NOTE: navigation + clearing the wizard are the caller's job (see buildRunStore),
// so the build can run in the background and survive the onboarding screen unmounting.
// NOTE: this function is NOT the live build path — the app builds through
// useBuildRunStore.start (server /builds job, or the local mini-app pipeline), and
// nothing outside tests calls runBuild(). The engine/mini-app runtime fork lives
// THERE, and deliberately only there: a second copy here was dead code that made the
// feature look wired up while the toggle did nothing. `withKind` above is still
// imported by finalizeBuild.
export async function runBuild(signedIn: boolean): Promise<{ projectId: string }> {
  const inputs = buildInputsFromStore(signedIn);

  const { definition, summary } = await buildAppDefinition(inputs, {
    generate: (i) => guided().generate(i),
    populate: appPopulate,
    generateImage: (prompt, aspect, opts) => guided().generateImage(prompt, signedIn, aspect, opts).then((r) => r.url),
  });
  return finalizeBuild(inputs.appName, inputs.goal, definition, summary);
}
